export default __webpack_public_path__ + "static/media/mobile_beehive_status_uk.e73a7e68.png";